import { render, staticRenderFns } from "./MarketViewEventLiveDetailConfigFromSettings.vue?vue&type=template&id=b17a628a"
import script from "./MarketViewEventLiveDetailConfigFromSettings.vue?vue&type=script&lang=js"
export * from "./MarketViewEventLiveDetailConfigFromSettings.vue?vue&type=script&lang=js"
import style0 from "./MarketViewEventLiveDetailConfigFromSettings.vue?vue&type=style&index=0&id=b17a628a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports